<template>
  <section class="error-container">
    <div
      class="error-img">
      <img
        src="~@/assets/img/error.svg"
        alt="error">
      <div class="error-code">
        <h4>{{ $route.params.error_code ? $route.params.error_code : 400 }}</h4>
        <h6>ERROR</h6>
      </div>
    </div>
    <h1 class="error-title">{{ $route.params.title ? $route.params.title : 'Whoops!' }}</h1>
    <p class="error-description">
      {{ $route.params.description ? $route.params.description : 'Something went wrong.' }}
    </p>
    <a
      v-if="$route.params.action_link"
      :href="$route.params.action_link"
      class="btn btn-main btn-round">{{ $route.params.action_title }}</a>
    <router-link
      v-else
      :to="{ name: 'FrontPage' }"
      class="btn btn-main btn-round">
      Home
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'ErrorPage',
};
</script>
